<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import UpdateUser from 'services/account/updateUser';
  import URLconfigs from 'services/apiConfigs';
  /* Services ------------------------------------------------------------------------ */
  import authenticationServices from 'features/authentication/authentication.services';
import { EventBus } from '../../../utils/event-bus';
  export default Vue.extend({
    name: "Onboarding",
    data() {
      return {
        title: "Getting Started"
      };
    },
    computed: {
      ...mapGetters(['getProfile', 'getCourses', 'getInstructorCourses', 'getParticipantCourses']),
    },
    methods: {
      handleCloseModal: async function() {
        try {
          UpdateUser(this.getProfile.id, { is_onboarded: true });
          this.$store.dispatch('updateAccount', { is_onboarded: true });
          this.$emit('close');
        } catch (error) {
          console.error(error);
        }
      },
      handleBrowseUniverse: function() {
        const universe_url = `${URLconfigs.universeURL}/roundtables/browse`;
        authenticationServices.navigateToExternalWithAuth(universe_url);
      },
      handleOpen: function() {
        UpdateUser(this.getProfile.id, { is_onboarded: true });
        this.$store.dispatch('updateAccount', { is_onboarded: true });
        this.$emit('close');
        EventBus.$emit('handleOpenWhatIsRoundtable');
      }
    },
    mounted: async function () {},
  });
</script>
<template>
  <pl-dialog :title="title" size="relative_lg" :disableOutsideClick="true" @close="handleCloseModal()"> 
    <div class="flex flex-col rounded-md mx-6 h-full mb-6 space-y-5 overflow-y-auto">
      <div class="relative h-44 w-full overflow-hidden rounded-lg ">
        <img src="/static/getting_started/getting_started.png" class="w-full h-full object-cover rounded-lg " alt="Parlay" />
        <div class="absolute inset-0 flex items-center justify-center">
          <span class="text-white text-4xl font-semibold font-poppins select-none">Welcome to Parlay!</span>
        </div>
      </div>
      <div class="flex flex-col flex-grow space-y-6 h-full overflow-y-auto">
        <div class="flex flex-col space-y-1.5">
          <h3 class="font-poppins text-blueGray-800 text-2xl font-semibold">Ready for remarkably deep class discussions?</h3>
          <p class="text-blueGray-700 text-base">Let's start your Parlay journey</p>
        </div>
        <div class="grid grid-cols-1 xl:grid-cols-3 gap-x-3 gap-y-3">
          <div class="bg-white border border-solid border-gray-200 rounded px-5 py-4 space-y-3">
            <div class="flex flex-col space-y-1.5">
              <h5 class="font-manrope text-base text-blueGray-800 font-bold">Create a discussion activity</h5>
              <p>Plan your first discussion activity in seconds!</p>
            </div>
            <div class="flex justify-between items-center">
              <button class="hover:underline">Learn more</button>
              <button @click="handleCloseModal()" class="px-4 py-2 bg-primary rounded text-white hover:bg-primary-dark">New RoundTable</button>
            </div>
          </div>
          <div class="bg-white border border-solid border-gray-200 rounded px-5 py-4 space-y-3">
            <div class="flex flex-col space-y-1.5">
              <h5 class="font-manrope text-base text-blueGray-800 font-bold">Browse Universe</h5>
              <p>Explore over 7,000 teacher-created discussion prompts!</p>
            </div>
            <div class="flex justify-between items-center">
              <button class="hover:underline">Learn more</button>
              <button @click="handleBrowseUniverse()" class="px-4 py-2 bg-pinky rounded text-white hover:bg-pinky-dark">Browse Topics</button>
            </div>
          </div>
          <div class="bg-white border border-solid border-gray-200 rounded px-5 py-4 space-y-3">
            <div class="flex flex-col space-y-1.5">
              <h5 class="font-manrope text-base text-blueGray-800 font-bold">Explore Discussion Types</h5>
              <p>Understand how Written and Verbal RoundTables work.</p>
            </div>
            <div class="flex justify-end items-center">
              <button @click="handleOpen()" class="px-4 py-2 bg-white border border-solid border-gray-200 rounded text-gray-800 hover:bg-gray-50">Learn More</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </pl-dialog>
</template>



// WEBPACK FOOTER //
// Onboarding.vue?465dd2f0